<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Keyword Details
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/keywords_list">Back</router-link></li>        
        <li class="active">Add / Update Keyword</li>
      </ol>
    </section>
    <div class="modal-mask"  v-if="showModal" id="Modal">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header" style="width:100%;">
             <label align="center">Welcome Messages</label>
          </div>

          <div class="modal-body">
            <slot name="body">
               <div v-bind:class="['alert', 'alert-' + alert.type, 'alert-dismissible']" v-if="alert.show">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <font color="black">{{alert.message}}</font>
              </div>
              <div  style="overflow: auto; height : 500px">
              <table class="table table-striped" style="width=100%">
                 <tbody v-if="allRows[0].config">
                  <tr v-bind:key="index" v-for="(row, index) in configNewListCopy">
                    <td style="width: 30%;">{{row['title']}}</td>

                    <td>
                          <table class="table table-striped" style="width=100%">
                          <tr v-bind:key="key" v-for="(langRow, key) in row['language']">
                            <td>{{langRow['langName']}}</td>
                                          

                             <td> <textarea  v-model="langRow.message" class="form-control" rows="4" id="langageMessage" placeholder="Message"></textarea></td>
                          </tr>
                          </table>
                    </td>
                  </tr>        
                  
                </tbody>
               </table>
               </div>


               <!-- <table class="table table-striped msg-table" style="display:none">
                <thead>
                  <th class="text-center">Name</th>
                  <th class="text-center">{{primaryLangText}}</th>
                  <th class="text-center">{{secondaryLangText}}</th>        
                  <th class="text-center" style="width:53px">Action</th>
                </thead>
                <tbody v-if="allRows[0].config">
                  <tr v-bind:key="key" v-for="(row, key, index) in primaryLanguageData">
                    <td>{{keywordTitles[key]}}</td>
                    <td v-bind:id="'primary_'+key" v-bind:ref="'primary_'+key" align="center">{{primaryLanguageData[key]}}</td>
                    <td v-bind:id="'secondary_'+key" v-bind:ref="'secondary_'+key" align="center">{{secondaryLanguageData[key]}}</td>          
                    
                    <td style="width:53px" v-bind:ref="'action_'+key">
                      <i  class="fa fa-pencil" aria-hidden="true" @click="editPopupMsg($event, key)" id="edit_{{key}}"></i>
                      <i style="display:none; float: left; margin-right: 4px; font-size: 16px;" class="fa fa-check-circle" aria-hidden="true" @click="savePopupMsg($event, key, index)" id="save_{{key}}"></i>
                      <i style="display:none; float: left; margin-right: 4px; font-size: 16px;" class="fa fa-times-circle" aria-hidden="true" @click="cancelPopupMsg($event, key)" id="cancel_{{key}}"></i>
                    </td>
                  </tr>        
                </tbody>
                <tbody v-if="!allRows[0].config">
                  <tr>
                    <td colspan="5" align="center">No result found</td>          
                  </tr>
                </tbody>
              </table> -->
            </slot>
          </div>

          <div class="modal-footer" style="width:100%">
            <slot name="footer">
              <button class="btn btn-primary" @click="showModal = false">
                Close
              </button>
                <button class="btn btn-primary" @click="closePopup()">
                Save
              </button>
              
            </slot>
          </div>
        </div>
      </div>
    </div>
    <section class="content">
      <form @submit.prevent="addOrUpdate" action="#"  method="post">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Keyword Configuration</h3>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="form-group col-xs-4 col-sm-4 col-md-4">
                <div class="padding-15px">
                  <label for="name" class="required">Keyword</label>
                  <!-- v-bind:style=" !isEdit ? 'text-transform: lowercase;' : '' " -->
                  <input type="text"  v-bind:class="{'form-group--error': (submitted && !$v.gRowObj.keyword.required) || keywordExistError }" v-model="gRowObj.keyword" class="form-control" id="keyword" placeholder="Keyword"  @input="generateLink"/>
                  <span v-if="submitted && !$v.gRowObj.keyword.required" class="text-red pull-right">Please enter keyword.</span>
                  <span v-if="submitted && keywordExistError" class="text-red pull-right">Keyword already exists.</span>
                </div>
              </div>
              <div class="form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2">
                <div class="padding-15px">
                  <label for="name" class="required">Type</label>
                  <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.appPackage.required }"  id="apppackage" name="apppackage" v-model="gRowObj.appPackage" @change="onChangeType($event)">
                      <option value="">--Choose an App Package--</option>
                      <option v-for="(data, index) in appPackages" :key="index" :value="data.value">{{data.name}}</option>
                  </nv-select>
                  <span v-if="submitted && !$v.gRowObj.appPackage.required" class="text-red pull-right">Please choose an app package.</span>
                </div>
              </div>
          </div>
           <div class="row">
            <div class="form-group col-xs-4 col-sm-4 col-md-4">
            <div class="padding-15px">
              <div class="reload-keyword">
              <label for="name" v-show="gRowObj.appPackage!=='journey'" style="margin-right: 10px"
              :class="{'required' : gRowObj.appPackage == 'conversation'}">Conversation</label>
              <label for="name" v-show="gRowObj.appPackage==='journey'" style="margin-right: 10px"
              :class="{'required' : gRowObj.appPackage == 'journey'}">User Journey</label>
              <div class="refresh-conversation-keyword">
                <a href="#"><div title="Click to refresh the contents of the list" class="fa fa-refresh rotate" @click="loadApps(true, true)"></div></a>
              </div>
              </div>
               <treeselect
                placeholder="--Choose an app--" 
                :multiple="false"
                :disabled="gRowObj.appPackage == ''"
                :options="conversationApps" 
                v-model="gRowObj.conversation"
                v-bind:class="{'form-group--error': submitted && !$v.gRowObj.conversation.required }" 
                @input="onChangeSelectedConversation" />
              <span v-if="submitted && !$v.gRowObj.conversation.required" class="text-red pull-right">Please choose an app.</span>
            </div>
          </div>
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2">
              <div class="padding-15px">
                <label for="conversationStage">Conversation Stage</label>
                <treeselect
                  placeholder="--Choose a stage--" 
                  :multiple="false"
                  :disabled="!gRowObj.conversation"
                  :options="conversationStages" 
                  v-model="gRowObj.conversationStage"
                  @input="onChangeConversationStage" />
              </div>
            </div>
        </div>
         <div class="row">
          <div class="form-group col-xs-4 col-sm-4 col-md-4">
            <div class="padding-15px">
              <label for="name">Description</label>
              <textarea  v-model="gRowObj.description" class="form-control" id="description" placeholder="description"></textarea>
              <!-- <span v-if="submitted && !$v.gRowObj.description.required" class="text-red pull-right">Please enter Description.</span> -->
            </div>
          </div>
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2">
              <div class="padding-15px">
                <label for="name" class="required">Country</label>                  
                <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country.required }" id="country" name="country" v-model="gRowObj.country"  @change="prepareLanguageData('reset')">
                    <option value="">--Choose a Country--</option>
                    <option v-for="(data, index) in country" :key="index" :selected="data.value === gRowObj.country" :value="data.value">{{data.name}}</option>                   
                </nv-select>
                <span v-if="submitted && !$v.gRowObj.country.required" class="text-red pull-right">Please choose country.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="panel-heading">
          <h3 class="panel-title">Onboarding Configuration</h3>
        </div>
        <div class="form-control" style="border: none;margin-top: 10px;">
          <div class="form-group col-md-12 col-lg-12 col-xs-12">
            <label class="radio-inline">
              <input v-model="onboardingMode" type="radio" value="genai" name="onboardingMode" @change="handleOnboardingChange">GenAI Onboarding
            </label>
            <label class="radio-inline">
              <input v-model="onboardingMode" type="radio" value="regular" name="onboardingMode" @change="handleOnboardingChange">Regular Onboarding
            </label>
            <label class="radio-inline">
              <input v-model="onboardingMode" type="radio" value="skip" name="onboardingMode" @change="handleOnboardingChange">Skip Onboarding
            </label>
          </div>
        </div>
        <div class="panel-body">
          <div class="row" v-show="onboardingMode === 'genai'">
            <div class="form-group col-xs-4 col-sm-4 col-md-4">
              <div class="padding-15px">
                <div>
                  <label for="name" style="margin-right: 10px" class="required">GenAI Onboarding Prompt Name</label>
                </div>
                <treeselect
                  placeholder="--Choose a prompt--" 
                  :multiple="false"
                  :options="promptList" 
                  v-model="gRowObj.setAdditionalDetails.promptId"
                  v-bind:class="{'form-group--error': submitted && !$v.gRowObj.setAdditionalDetails.promptId.required }" 
                />
                <span v-if="submitted && !$v.gRowObj.setAdditionalDetails.promptId.required" class="text-red pull-right">Please select prompt.</span>
              </div>
            </div>
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2">
              <div class="padding-15px">
                <label for="name">GenAI Ad Context</label>
                <textarea  v-model="gRowObj.setAdditionalDetails.adContext" class="form-control" id="description" placeholder="Enter keyword context"></textarea>
              </div>
            </div>
          </div>               
          <div class="row">
            <div class="form-group col-xs-4 col-sm-4 col-md-4">
              <div class="padding-15px">
                <label for="name" class="required">Default Language for welcome message</label>                  
                <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.language.required }" id="language" name="language" v-model="gRowObj.language">
                    <option value="">--Choose a Language--</option>
                    <option v-for="(data, index) in languages" :key="index" :selected="data.value === gRowObj.language" :value="data.value">{{data.name}}</option>                   
                </nv-select>
                <span v-if="submitted && !$v.gRowObj.language.required" class="text-red pull-right">Please choose language.</span>
              </div>
            </div>
            <div class="keyword-Location">
              <div class="form-group col-xs-4 col-sm-4 col-md-4 col-xs-offset-2 col-sm-offset-2 col-md-offset-2">
                <div class="padding-15px">
                  <label for="keywordLocation">Keyword Location</label>
                  <input @input="checkKeywordLocation()" type="text"  v-bind:class="{'form-group--error': searchWithoutKeywordLocation }" v-model="keywordLocation" class="form-control" id="keywordLocation" placeholder="Keyword Location"/>
                  <span v-if="searchWithoutKeywordLocation" class="text-red pull-right">Please enter keyword location.</span>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 keyword-location-data">
                  <div v-if="keywordLocationDataResp.administrativeLevels.administrative_area_level_1"><b>administrative_area_level_1: </b> <span class="custom-margin-left-3">{{ keywordLocationDataResp.administrativeLevels.administrative_area_level_1.long_name }}</span></div>
                  <div v-if="keywordLocationDataResp.administrativeLevels.administrative_area_level_2" class="custom-margin-top-3"><b>administrative_area_level_2: </b> <span class="custom-margin-left-3">{{ keywordLocationDataResp.administrativeLevels.administrative_area_level_2.long_name }}</span></div>
                  <div v-if="keywordLocationDataResp.administrativeLevels.administrative_area_level_3" class="custom-margin-top-3"><b>administrative_area_level_3: </b> <span class="custom-margin-left-3">{{ keywordLocationDataResp.administrativeLevels.administrative_area_level_3.long_name }}</span></div>
                  <div v-if="keywordLocationDataResp.administrativeLevels.administrative_area_level_4" class="custom-margin-top-3"><b>administrative_area_level_4: </b> <span class="custom-margin-left-3">{{ keywordLocationDataResp.administrativeLevels.administrative_area_level_4.long_name }}</span></div>
                  <div v-if="keywordLocationDataResp.locality" class="custom-margin-top-3"><b>locality: </b> <span class="custom-margin-left-3">{{ keywordLocationDataResp.locality }}</span></div>
                </div>
              </div>
              <div class="form-group col-xs-2 col-sm-2 col-md-2 keyword-location-search">
                <input type="button" class="btn btn-primary keyword-location-search-btn" @click="getKeywordLocationData()" value="Search">
                <button v-if="isLocationRedirectVisible" class="keyword-location-redirect-btn" type="button" @click="viewLocationOnMaps()" title="View Location on Maps"><i aria-hidden="true" class="fa fa-external-link"></i></button>
              </div>
            </div>        
          </div>
          <div class="row">
            <div class="form-group col-xs-12 col-sm-12 col-md-12">
              <div class="row" v-show="onboardingMode !== 'genai'">
                <div class="form-group col-md-12 col-lg-12 col-xs-12">
                  <div class="padding-15px">
                    <label class="checkbox-inline">
                      <input type="checkbox" name="setPreferredUserLanguage" id="setPreferredUserLanguage" :checked="gRowObj.setPreferredUserLanguage"  v-bind:value="gRowObj.setPreferredUserLanguage" v-model="gRowObj.setPreferredUserLanguage">Set first message language as user's preferred language and skip the language question during onboarding
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-xs-4 col-sm-4 col-md-4">
                  <div class="padding-15px">
                    <label for="name" class="required">Default Gender</label>                  
                    <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.setPreferredUserGender.required }" id="setPreferredUserGender" name="setPreferredUserGender" v-model="gRowObj.setPreferredUserGender">
                        <option value="ASK_THE_USER">Ask the user</option>
                        <option v-for="(data, index) in genderOptions" :key="index" :selected="data.value === gRowObj.setPreferredUserGender" :value="data.value">{{data.label}}</option>                   
                    </nv-select>
                    <span v-if="submitted && !$v.gRowObj.setPreferredUserGender.required" class="text-red pull-right">Please choose Gender.</span>
                  </div>
                </div>
                <div v-show="onboardingMode === 'genai'" class="form-group col-xs-4 col-sm-4 col-md-4 col-xs-offset-2 col-sm-offset-2 col-md-offset-2">
                  <div class="padding-15px">
                    <label for="name">Underage Limit</label>
                      <input type="number" placeholder="Enter lower age limit between 1 to 99" class="form-control" id="setUnderageLimit" name="setUnderageLimit" v-model="gRowObj.setAdditionalDetails.underageLimit" min="1" max="99" />
                  </div>
                </div>
              </div>
              <div class="row" v-show="onboardingMode === 'regular'">
                <div class="form-group col-md-12 col-lg-12 col-xs-12">            
                  <div class="padding-15px">
                    <label class="checkbox-inline">
                      <input type="checkbox" name="setEnableNlpOnboarding" id="setEnableNlpOnboarding" :checked="gRowObj.setEnableNlpOnboarding"  v-bind:value="gRowObj.setEnableNlpOnboarding" v-model="gRowObj.setEnableNlpOnboarding">Enable NLP based onboarding question
                    </label>
                  </div>
                </div>
              </div>
              <div class="row" v-show="onboardingMode !== 'genai'">
                <div class="form-group col-md-12 col-lg-12 col-xs-12">
                  <div class="padding-15px">
                    <label class="checkbox-inline">
                      <input type="checkbox" name="setAdditionalDetails" id="setAdditionalDetails" :checked="gRowObj.setAdditionalDetails.clubOptInLanguage"  v-bind:value="gRowObj.setAdditionalDetails.clubOptInLanguage" v-model="gRowObj.setAdditionalDetails.clubOptInLanguage">Club OptIn and Language Question
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12 col-lg-12 col-xs-12">            
                  <div class="padding-15px">
                    <label class="checkbox-inline">
                      <input type="checkbox" name="autoaccepttnc" id="autoaccepttnc" :checked="gRowObj.autoaccepttnc"  v-bind:value="gRowObj.autoaccepttnc" v-model="gRowObj.autoaccepttnc">Auto Accept Terms & Conditions?
                    </label>
                  </div>
                </div>
              </div>
              <div class="row" v-show="onboardingMode !== 'genai'">
                <div class="form-group col-md-12 col-lg-12 col-xs-12">
                  <div class="padding-15px">
                    <label class="checkbox-inline">
                    <input type="checkbox" name="customMessages" id="customMessages" :checked="gRowObj.customMessages" true-value="yes" false-value="no"  v-bind:value="gRowObj.customMessages" v-model="gRowObj.customMessages" @change="prepareConfigData">Use Custom Welcome Messages
                    </label>
                  </div>
                </div>
                <div class="form-group col-md-12 col-lg-12 col-xs-12" v-if="gRowObj.customMessages==='yes'">
                  <div class="padding-15px">
                    <div>
                      <input type="button" class="btn btn-primary" @click="openPopup()" value="Show Messages">
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
     <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Customer Information</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          
          <div class="form-group col-xs-4 col-sm-4 col-md-4">
            <div class="padding-15px v-autocomplete">
              <label for="client" class="required">Customer/Client</label>
               <nv-select   v-model="gRowObj.client" class="form-control" @change="onChangeClient($event)"  v-bind:class="{'form-group--error': submitted && !$v.gRowObj.client.required }" id="client" name="client">
                <option value="">--Choose a Client--</option>
                <option v-for="(client, index) in filteredClientData" :selected="client.name === gRowObj.client" :key="index" :value="client.name">{{client.name}}</option>
              </nv-select>
             <span v-if="submitted && !$v.gRowObj.client.required" class="text-red pull-right">Please choose Client.</span>     



              <!-- <input type="text"
                autocomplete="off"
                v-model="gRowObj.client"
                class="form-control"
                id="client"
                placeholder="Customer/Client"
                @input="autoCompClientData(gRowObj.client)"
                @focus="showClientAutoComplList = true"
                @blur="showClientAutoComplList = false"
                /> 
                <ul class="v-autocomplete-list" v-show="showClientAutoComplList && filteredClientData.length">
                  <li class="v-autocomplete-list-item" v-for="data in filteredClientData" v-bind:key="data" v-on:mousedown="gRowObj.client = data">{{ data }}</li>
                </ul> -->
              <!-- <autocomplete 
                :items="filteredClientData"
                placeholder="Customer/Client"
                type="text"
                input-class="form-control"
                @update-items="autoCompClientData"
                min-len="1"
                :auto-select-one-item="false">
              <autocomplete> -->
            </div>
          </div>  
          <div class="form-group col-xs-4 col-sm-4 col-md-4 col-md-offset-2">
            <div class="padding-15px v-autocomplete">
            <label for="client">Scout Menu:</label>  
              <!-- <nv-select v-if="gRowObj.conversation == ''" v-model="gRowObj.conversation" class="form-control">
                <option value="">--Choose an option--</option>                
              </nv-select>          
              <nv-select  v-if="gRowObj.conversation !== ''" v-model="gRowObj.scoutMenu" class="form-control">
                <option value="">--Choose an option--</option>
                <option v-for="(conv, index) in scoutMenus" :selected="conv.name === gRowObj.scoutMenu" :key="index" :value="conv.name">{{conv.name}} - {{formatDate(conv.deployedDate, 'd/M/Y hh:ss')}}</option>
              </nv-select> -->
              <input type="text" 
                autocomplete="off" 
                v-model="gRowObj.scout_menu" 
                class="form-control" 
                id="scout_menu" 
                placeholder="--Choose an option--"
                @input="autoCompleteScoutMenus(gRowObj.scout_menu)"
                @focus="showScoutMenuAutoComplList = true"
                @blur="showScoutMenuAutoComplList = false"                        
                 /> 
                <ul class="v-autocomplete-list-scout-menus" v-show="showScoutMenuAutoComplList && gRowObj.conversation && filteredScoutMenus.length">
                  <li class="v-autocomplete-list-item" v-for="data in filteredScoutMenus" v-bind:key="data.id" v-on:mousedown="gRowObj.scout_menu = data.id">{{ data.label }}</li>
                </ul>
            </div>
          </div>
        </div>

        
        <div class="row">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="client">Referral Display Priority</label>
              <div v-for="refPriority in referralPriorityOptions" :key="refPriority.value">
                <label class="radio-inline col-xs-6 col-sm-6 col-md-6">
                  <input v-model="gRowObj.referral_priority" :checked="gRowObj.referral_priority" type="radio" :value="refPriority.value" name="referral_priority">{{refPriority.label}}
                </label>
              </div>
            </div>
          </div> 
        </div>

      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Referral Configuration</h3>
      </div>
      <div class="panel-body">

        <div class="row" style="border: 1px red solid;">
          <div style="padding: 10px;color: red;font-size: medium;font-weight: bold;">
          UNDER CONSTRUCTION: DO NOT USE THIS SECTION
          </div>
          <!-- <div class="form-group col-xs-4 col-sm-4 col-md-4">
            <div class="padding-15px v-autocomplete">
              <label for="client">Customer/Client</label>
               <nv-select   v-model="gRowObj.customer" class="form-control"   id="customer" name="customer">
                <option value="">--Choose a Customer--</option>
                <option v-for="(customer, index) in filteredClientData" :selected="customer.name === gRowObj.customer" :key="customer.id" :value="customer.name">{{customer.name}}</option>
              </nv-select>
            </div>
          </div>  -->

          <div class="form-group col-xs-12 col-sm-12 col-md-12">
            <div class="padding-15px v-autocomplete">
              <label for="client">Select referral refinements below to EXCLUDE from results:</label>
            <!-- <ul>
              <li class="checkbox-inline" style="width:100px"> <label> <strong> Ownership : </strong> </label> </li>
              <li class="checkbox-inline"> 
                <label class="checkbox-inline"><input type="checkbox" :value="All" @click="selectAllReferral('ownership')" v-model="allSelectedRefOwnership" /> All</label>
              </li>
              <li v-for="(ownership, index) in refOwnershipData"  class="checkbox-inline">
                  <label class="checkbox-inline">
                  <input  type="checkbox" v-model="gRowObj.refOwnership" :value="ownership.id" @click="selectReferral('ownership')"/>{{ownership.name}}
                  </label>
              </li>
           </ul>

            <ul class="hide">
              <li class="checkbox-inline" style="width:100px"> <label> <strong> Category : </strong> </label> </li>
               <li class="checkbox-inline"> 
                <label class="checkbox-inline"><input type="checkbox" :value="All" @click="selectAllReferral('category')" v-model="allSelectedRefCategory" /> All</label>
              </li>
              <li v-for="(category, index) in refCategoryData"  class="checkbox-inline">
                  <label class="checkbox-inline">
                  <input  type="checkbox" v-model="gRowObj.refCategory" :value="category.id" @click="selectReferral('category')"/>{{category.name}}
                  </label>
              </li>
           </ul>

            <ul>
              <li class="checkbox-inline"  style="width:100px"> <label> <strong> Services : </strong> </label> </li>
               <li class="checkbox-inline"> 
                <label class="checkbox-inline"><input type="checkbox" :value="All" @click="selectAllReferral('service')" v-model="allSelectedRefService" /> All</label>
              </li>
              <li v-for="(service, index) in refServiceData"  class="checkbox-inline">
                  <label class="checkbox-inline">
                  <input  type="checkbox" v-model="gRowObj.refService" :value="service.id" @click="selectReferral('service')"/>{{service.name}}
                  </label>
              </li>
           </ul>

           <ul>
              <li class="checkbox-inline"  style="width:100px"> <label> <strong> Access : </strong> </label> </li>
               <li class="checkbox-inline" > 
                <label class="checkbox-inline"><input type="checkbox" :value="All" @click="selectAllReferral('access')" v-model="allSelectedRefAccess" /> All</label>
              </li>
              <li v-for="(access, index) in refAccessData"  class="checkbox-inline">
                  <label class="checkbox-inline">
                  <input  type="checkbox" v-model="gRowObj.refAccess" :value="access.id" @click="selectReferral('access')"/>{{access.name}}
                  </label>
              </li>
           </ul> -->

            <ul>
              <li class="radio-inline"  style="width:150px"> <label> <strong> Ownership : </strong> </label> </li>
              <li v-for="(ownership, index) in refOwnershipData" class="radio-inline" :key="index">
                 <label class="radio-inline">
                  <input type="radio" name="ref_ownership" :value="ownership.type_name" :checked="gRowObj.ref_ownership" v-model="gRowObj.ref_ownership">{{ownership.type_name}}
                </label>
              </li>  
           </ul>

            <ul>
              <li class="radio-inline"  style="width:150px"> <label> <strong> Physical/Virtual : </strong> </label> </li>
              <li v-for="(access, index) in refAccessData" class="radio-inline" :key="index">
                 <label class="radio-inline">
                  <input type="radio" name="ref_access" :value="access.type_name" :checked="gRowObj.ref_access" v-model="gRowObj.ref_access">{{access.type_name}}
                </label>
              </li>  
           </ul>

            <ul>
              <li class="radio-inline"  style="width:150px"> <label> <strong> Medical/Pharmacy : </strong> </label> </li>
              <li v-for="(service, index) in refServiceData" class="radio-inline" :key="index">
                 <label class="radio-inline">
                  <input type="radio" name="ref_service" :value="service.type_name" :checked="gRowObj.ref_service" v-model="gRowObj.ref_service">{{service.type_name}}
                </label>
              </li>  
           </ul>

            


            </div>
          </div> 
        </div>

        <div class="row">
          <!-- <div class="form-group col-md-12 col-lg-12 col-xs-12">  
            <div class="padding-15px">
              <label for="facilities">Facilities
                
              </label> 
              <span> (Note: To add/update facilities to Keyword select and move them to the right section.)</span>
              <DualListBox
                  :source="source" 
                  :destination="destination"
                  label="name"
                  @onChangeList="onChangeList"
                  @searchFacilities="searchFacilities"
                  @getFacilitiesExceptSelected="getFacilitiesExceptSelected"
              />
            </div>
          </div> -->

          <div class="form-group col-md-12 col-lg-12 col-xs-12">  
            <div class="panel-group padding-15px">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <h4 class="panel-title">
                    <a data-toggle="collapse" href="#collapse1" @click="isFacilityPanelActive = isFacilityPanelActive ? false : true">
                      <i  v-bind:class="[isFacilityPanelActive ? 'fa fa-minus' : 'fa fa-plus']" style="padding-right: 5px;"></i>
                      <strong >Facilities                
                      </strong> 
                      <span> (Note: To add/update facilities to Keyword select and move them to the right section.)</span>
                    </a>
                  </h4>
                </div>
                <div id="collapse1" class="panel-collapse collapse" style="padding:2px">
                  <div class="card-body">
                    <DualListBox
                    :source="source" 
                    :destination="destination"
                    label="name"
                    @onChangeList="onChangeList"
                    @searchFacilities="searchFacilities"
                    @getFacilitiesExceptSelected="getFacilitiesExceptSelected"
                      />
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="row">
          <div class="form-group col-md-3 col-lg-3 col-xs-3">
            <div class="padding-15px">
              <label class="checkbox-inline">
              <input type="checkbox" name="QRCode" id="QRCode" v-model="gRowObj.isQRCode" @change="checkQRCodePlacement($event)">QR code available
              </label>
            </div>
          </div>
          <div class="form-group col-md-5 col-lg-5 col-xs-5" style="margin-top: -10px;">
            <label for="referralResource">Referral Resource</label>
            <treeselect
              style="width: 70%;"
              id="referralResource"
              placeholder="--Choose an Referral Resource--" 
              :multiple="false"
              :async="true"
              :defaultOptions="true"
              :load-options="loadOptions"
              :cacheOptions="false"
              v-model="gRowObj.referralResource" />
          </div>
          <div class="form-group col-md-4 col-lg-4 col-xs-4" style="margin-top: -10px;">
            <label for="qrCodePlacement">QR code placement</label>
            <nv-select :disabled="gRowObj.isQRCode == false" id="qrCodePlacement" class="form-control" name="qrCodePlacement" v-model="gRowObj.qrCodePlacement" style="width: 80%;">
                <option value="">--Choose a QR code placement--</option>
                <option v-for="(data, index) in qrCodePlacementOptions" :key="index" :value="data.value">{{data.name}}</option>
            </nv-select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-lg-12 col-xs-12">
            <div class="padding-15px" style="margin-top: -30px;">
              <label class="checkbox-inline">
              <input type="checkbox" name="referralcode" id="referralcode" :checked="gRowObj.referralcode"  v-bind:value="gRowObj.referralcode" v-model="gRowObj.referralcode">Send Referral Code
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Keyword Metadata</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="form-group col-xs-4 col-sm-4 col-md-4">
              <div class="padding-15px">
                <label for="name" class="required">Channel</label>                  
                <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.channel.required }" id="channel" name="channel" v-model="gRowObj.channel">
                    <option value="">--Choose a Channel--</option>
                    <option v-for="(data, index) in channels" :key="index" :value="data.value">{{data.name}}</option>
                </nv-select>
                <span v-if="submitted && !$v.gRowObj.channel.required" class="text-red pull-right">Please choose channel.</span>                  
              </div>
            </div>

           <div class="form-group col-xs-4 col-sm-4 col-md-4">
            <div class="padding-15px v-autocomplete">
              <label for="tag">Tags</label>
              <!-- <input type="text"  v-model="gRowObj.tag" class="form-control" id="tag" placeholder="Tags"  /> -->
              <input type="text" 
                autocomplete="off" 
                v-model="gRowObj.tag" 
                class="form-control" 
                id="tag" 
                placeholder="Tag"
                @input="autoCompTagData(gRowObj.tag)"
                @focus="showTagAutoComplList = true"
                @blur="showTagAutoComplList = false"
                 /> 
                <ul class="v-autocomplete-list" v-show="showTagAutoComplList && filteredTagData.length">
                  <li class="v-autocomplete-list-item" v-for="data in filteredTagData" v-bind:key="data" v-on:mousedown="gRowObj.tag = data">{{ data }}</li>
                </ul>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="form-group col-xs-4 col-sm-4 col-md-4">
               <div class="padding-15px v-autocomplete">
              <label for="keyword_usage" class="required">Keyword Use</label>
              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.keyword_usage.required }" id="keyword_usage" name="keyword_usage" v-model="gRowObj.keyword_usage">
                    <option value="">--Choose a Option--</option>
                    <option v-for="(data, index) in keywordUseList" :key="index" :value="data.usage_type">{{data.labels}}</option>
                </nv-select>
                <span v-if="submitted && !$v.gRowObj.keyword_usage.required" class="text-red pull-right">Please choose Option.</span>  
              </div>
            </div>
              <div class="form-group col-xs-4 col-sm-4 col-md-4">
               <div class="padding-15px v-autocomplete">
              <label for="keyword_usage" class="required">Keyword Topic</label>
              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.topic.required }" id="topic" name="topic" v-model="gRowObj.topic">
                    <option value="">--Choose a Option--</option>
                    <option v-for="(data, index) in topicList" :key="index" :value="data.display_name">{{data.display_name}}</option>
                </nv-select>
                <span v-if="submitted && !$v.gRowObj.topic.required" class="text-red pull-right">Please choose Option.</span>  
              </div>
            </div>
        </div>
      </div>
    </div> 

    <div class="panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Campaign Information</h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="form-group col-xs-4 col-sm-4 col-md-4">
            <div class="padding-15px v-autocomplete">
              <label for="campaign" class="required">Campaign</label> &nbsp;               
              <nv-select   v-model="gRowObj.campaign" class="form-control"  v-bind:class="{'form-group--error': submitted && !$v.gRowObj.campaign.required }" id="campaign" name="campaign">
                <option value="">--Choose a Campaign--</option>
                <option v-for="(campaign, index) in filteredCampaignData" :selected="campaign.name === gRowObj.campaign" :key="index" :value="campaign.name">{{campaign.name}}</option>
              </nv-select>
               <span v-if="submitted && !$v.gRowObj.campaign.required" class="text-red pull-right">Please choose Campaign.</span>     
            </div>
            <div class="padding-15px v-autocomplete" style="margin-top: 8px">
              <label for="utm_source">Utm Source</label>
              <input type="text"
                v-model="gRowObj.utm_source"
                autocomplete="off"
                class="form-control" 
                id="utm_source"
                placeholder="Utm Source"
                @input="generateLink"
               />
            </div>
            <!-- <div class="padding-15px v-autocomplete" style="margin-top: 8px">
              <label for="utm_campaign">Utm Campaign</label>
              <input type="text"
                v-model="gRowObj.utm_campaign"
                autocomplete="off"
                class="form-control" 
                id="utm_campaign" 
                placeholder="Utm Campaign"
                @input="generateLink"
               />
            </div> -->
              <!-- <div class="padding-15px">
                <div>
                  <input id="copyClipboardLink" type="button" class="btn btn-primary" @click="generateLink()" value="Generate Link">
                </div>
              </div> -->
          </div>
          

            <div class="form-group col-xs-2" style="margin-top: 25px;">
                        <input type="button" class="btn btn-primary" @click="openCampaignModel()" value="Create New">            
                        <div class="modal-backdrop" v-if="showCampaignModal" id="ModalCampaign">
                            <div class="modal modal-md" style="height: 200PX;max-width:600px">
                              <header class="modal-header">
                                <slot name="header">
                                  <h3>Add Campaign</h3>
                                </slot>
                                <div class="modal-body">
                                  <slot name="body">
                                  <div class="form-horizontal">
                                    <div class="form-group">
                                      <label for="campaign" style="font-weight:500" class="col-sm-4 control-label required">Campaign Name</label>
                                      <div class="col-sm-8">
                                        <input type="text" class="form-control" autocomplete="off" id="campaignNew" placeholder="Campaign Name" v-model="gRowObj.campaignNew" 
                                        v-bind:class="{'form-group--error': (isSubmittedNewCampaign && !gRowObj.campaignNew)}" 
                                          />
                                        <span v-if="isSubmittedNewCampaign && !gRowObj.campaignNew" class="text-red pull-right" style="font-size:initial">Please enter Campaign Name</span>
                                      </div>
                                    </div>
                                    <div class="form-group pull-right">
                                      <div class="col-sm-12">
                                        <button type="button" class="btn btn-primary" @click="closeCampaign">Cancel</button>
                                        <button type="button" class="btn btn-primary" @click="addCampaign">Submit</button>
                                      </div>
                                    </div>
                                  </div>
                                  </slot>
                                </div>
                              </header>
                              <footer class="modal-footer"></footer>
                            </div>
                          </div>

            </div>

            <div class="form-group col-xs-4">
             
            <div class="padding-15px v-autocomplete">
               <label for="campaignCode">Campaign Code</label>
               <a href="javascript:void(0)" @click="copyCampaign" v-if="gRowObj.campaignCode">(Copy Current Code)</a>
                  <!-- <h3 class="panel-title"><p class="text-primary">{{gRowObj.campaignCode}}</p></h3> -->
                  <!-- <input type="text"
                  :disabled="gRowObj.client == ''"
                  autocomplete="off"
                  v-model="gRowObj.campaignCode"
                  class="form-control"
                  id="campaignCode"
                  placeholder="Campaign Code"
                  @input="autoCompCampgainCodeData(gRowObj.campaignCode)"
                  @focus="showCampaignAutoComplCodeList = true"
                  @blur="showCampaignAutoComplCodeList = false"
                  />  -->

                  
                  <!-- <ul class="v-autocomplete-list" v-show="showCampaignAutoComplCodeList && filteredCampgainCodeData.length">
                    <li class="v-autocomplete-list-item" v-for="data in filteredCampgainCodeData"  v-bind:key="data" v-on:mousedown="gRowObj.campaignCode = data.code">{{ data.code }}</li>
                  </ul> -->

                  <input type="text" v-show="false" class="form-control" autocomplete="off" id="campaignCode" placeholder="Campaign Code" v-model="gRowObj.campaignCode" >
                  <input type="text"
                    v-model="gRowObj.utm_campaign"
                    autocomplete="off"
                    class="form-control" 
                    id="utm_campaign" 
                    placeholder="Campaign Code"
                    @input="generateLink"
                  />

            </div> 
            <div class="padding-15px v-autocomplete" style="margin-top: 8px">
              <label for="utm_medium">Utm Medium</label>
              <input type="text"
                  v-model="gRowObj.utm_medium"
                  autocomplete="off"
                  class="form-control" 
                  id="utm_medium" 
                  placeholder="Utm Medium"
                  @input="generateLink"
                />
                <!-- <div class="style-text-link">
                  <div class="copyToClipborad">
                    <i class="fa fa-clipboard" aria-hidden="true" @click="copyLink" v-if="gRowObj.keyword" title="Copy Link"></i>
                  </div>   
                </div> -->
            </div>
          </div> 
          <div class="form-group col-xs-2" >
            <div style="margin-top: 25px;">
              <div>
                <input type="button" class="btn btn-primary" @click="generateCampaignCode()" value="Generate code" :disabled="gRowObj.client == ''">
              </div>
            </div> 
          </div>           
        </div>
        <div class="padding-15px">
              <div class="style-text-resultingLink" v-if="resultingLink">
                <b>URL Parameters:-</b>
                <div class="style-text-resultingLink">
                <div class="link" ref="paramLink" id="paramLink">
                    {{ resultingLink }}
                </div>
              <div class="copyToClipborad">
                <i class="fa fa-clipboard" aria-hidden="true" @click="copyLink" title="Copy URL Parameters" style="font-size: 17px"></i>
              </div> 
              </div>
              </div>
            </div>
      </div>
    </div>
   
        <!-- <div class="row">
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="type">Type</label>                  
              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.type.required }" id="type" v-model="gRowObj.type">
                  <option value="">--Choose an App Type--</option>
                  <option v-for="(data, index) in appTypes" :key="index" :selected="data.value === gRowObj.type" :value="data.value">{{data.name}}</option>                      
              </nv-select>
              <span v-if="submitted && !$v.gRowObj.type.required" class="text-red pull-right">Please choose an app type.</span>
            </div>
          </div>
          <div class="form-group col-xs-6 col-sm-6 col-md-6">
            <div class="padding-15px">
              <label for="product">Product</label>
              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.product.required }" id="product" name="product" v-model="gRowObj.product">
                  <option value="">--Choose a Product--</option>
                  <option v-for="(data, index) in products" :key="index" :selected="data.value === gRowObj.product" :value="data.value">{{data.name}}</option>                     
              </nv-select>
              <span v-if="submitted && !$v.gRowObj.product.required" class="text-red pull-right">Please choose product.</span>
            </div>
          </div>
        </div> -->
        
        <!-- <div class="row">
          <div class="col-md-12 col-lg-12 col-xs-12">
            <div class="form-group">
              <div class="padding-15px">
                <label for="weightage">Weightage</label>
              </div>
              <div class="padding-15px">
                <label class="radio-inline">
                  <input type="radio" name="weightage" value="primary" :checked="gRowObj.weightage" v-model="gRowObj.weightage">Primary
                </label>
                <label class="radio-inline">
                  <input type="radio" name="weightage" value="secondary" :checked="gRowObj.weightage" v-model="gRowObj.weightage">Secondary
                </label>     
              </div>         
            </div>
          </div>
        </div> -->

        <!-- <div class="row">
          <div class="col-md-6 col-lg-6 col-xs-6">
            <label for="weightage">Weightage dummy</label>
            <div class="form-group">
              <label class="radio-inline">
                <input type="radio" name="weightage" value="primary" v-model="weightage">Primary
              </label>
              <label class="radio-inline">
                <input type="radio" name="weightage" value="secondary" v-model="weightage">Secondary
              </label>              
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xs-6">
            <label for="weightage">Weightage dummy</label>
            <div class="form-group">
              <label class="radio-inline">
                <input type="radio" name="weightage" value="primary" v-model="weightage">Primary
              </label>
              <label class="radio-inline">
                <input type="radio" name="weightage" value="secondary" v-model="weightage">Secondary
              </label>              
            </div>
          </div>
        </div>-->

        

         
        <!-- <div class="row">
          <div class="form-group col-md-12 col-lg-12 col-xs-12">
            <div class="padding-15px">
              <label>Exclusive</label>
            </div>
            <div class="padding-15px">
              <label class="checkbox-inline">
                <input type="checkbox" name="isExclusive" id="isExclusive" :checked="gRowObj.isExclusive"  v-bind:value="gRowObj.isExclusive" v-model="gRowObj.isExclusive"> Is Exclusive?
              </label>
            </div>
          </div>
        </div>  -->
        <div class="row">
        </div>
        <div class="row">
          <div class="action-button">
            <button type="button" class="btn btn-primary" @click="close">Cancel</button>
            <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
          </div>
        </div>
      </form>
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import { required, requiredIf } from 'vuelidate/lib/validators'
  import DualListBox from './DualListBox'
  import _ from 'lodash'
  import api from '../../../utils/api'
  import { formatDate, getSelectorValue, getEnv } from '../../../utils/utilities'
  import { appTypes, products, appPackages, channels, languages, genderOptions } from './../../../config/constants'
  import { referralPriorityOptions, qrCodePlacementOptions } from './constants'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

  export default {
    name: 'modal',
    validations: {
      gRowObj: {
        keyword: { required },
        type: { required },
        product: { required },
        appPackage: { required },
        channel: { required },
        client: { required },
        campaign: { required },
        language: { required },
        setPreferredUserGender: { required },
        country: { required },
        keyword_usage: { required },
        topic: { required },
        conversation: {
          required: requiredIf(function () {
            return this.gRowObj.appPackage === 'conversation' || this.gRowObj.appPackage === 'journey'
          })
        },
        setAdditionalDetails: {
          promptId: {
            required: requiredIf(function () {
              return this.onboardingMode === 'genai' && (this.gRowObj.appPackage === 'conversation' || this.gRowObj.appPackage === 'journey')
            })
          }
        }
      }
    },
    components: {
      DualListBox
    },
    data () {
      return {
        onboardingMode: 'regular',
        promptList: [],
        isSubmittedNewCampaign: false,
        checkConvoOrJourney: '',
        isFacilityPanelActive: false,
        referralResourceTypeList: [],
        keywordUseList: [],
        topicList: [],
        showModal: false,
        showCampaignModal: false,
        showWarning: false,
        showSuccess: false,
        currentScoutMenuIndex: 0,
        alert: {
          show: false,
          type: '', // success, info, warning, danger
          message: ''
        },
        allSelectedRefOwnership: false,
        allSelectedRefCategory: false,
        allSelectedRefService: false,
        allSelectedRefAccess: false,
        keywordOldName: '',
        campaignOldCode: '',
        countryOldName: '',
        allRows: {},
        clientData: {},
        campaignData: {},
        campgainCodeData: [],
        configNewList: [],
        configNewListCopy: [],
        tagData: {},
        focusClientAutoComplList: false,
        showCampaignAutoComplList: false,
        showCampaignAutoComplCodeList: false,
        showClientAutoComplList: false,
        showTagAutoComplList: false,
        showScoutMenuAutoComplList: false,
        filteredCampaignData: {},
        filteredClientData: {},
        backupKeywordConfig: {},
        refServiceData: {},
        refCategoryData: {},
        refOwnershipData: {},
        refAccessData: {},
        filteredCampgainCodeData: {},
        filteredTagData: {},
        filteredScoutMenus: {},
        originalLanguageData: {},
        search: '',
        conversationApps: [],
        conversationStages: [],
        scoutMenus: [],
        conversationAppCopy: [],
        formatDate: formatDate,
        source: [],
        destination: [],
        loading: false,
        keywordExistError: false,
        msg: 'Please wait...',
        selectedItems: [],
        languageList: [],
        selected: null,
        selectedFacilities: [],
        appTypes: appTypes,
        products: products,
        appPackages: appPackages,
        channels: channels,
        languages: languages,
        genderOptions: genderOptions,
        referralPriorityOptions: referralPriorityOptions,
        qrCodePlacementOptions: qrCodePlacementOptions,
        country: [],
        countryLanguageList: [],
        validationErrors: [],
        gRowObj: {
          id: null,
          keyword: '',
          conversation: null,
          type: 'chat',
          product: 'asknivi',
          appPackage: '',
          locationid: '',
          channel: '',
          language: '',
          country: '',
          facilities: '',
          campaign: '',
          messages: '',
          client: '',
          referral_priority: 1,
          mongo_id: '',
          description: '',
          tag: '',
          overrideuserlocation: '',
          createdAt: new Date(),
          autoaccepttnc: false,
          setPreferredUserLanguage: false,
          setEnableNlpOnboarding: false,
          setAdditionalDetails: {},
          setPreferredUserGender: 'ASK_THE_USER',
          referralcode: false,
          weightage: 'primary',
          isExclusive: false,
          customMessages: 'no',
          editedCustomMsg: '',
          customConfig: {},
          primaryLangText: {},
          secondaryLangText: {},
          primaryLanguageData: {},
          secondaryLanguageData: {},
          campaignCode: '',
          campaignNew: '',
          ref_ownership: '',
          ref_service: '',
          ref_access: '',
          keyword_usage: '',
          topicId: '',
          topic: '',
          scout_menu: '',
          referralResource: null,
          isQRCode: false,
          qrCodePlacement: '',
          utm_source: '',
          utm_medium: '',
          utm_campaign: ''
        },
        resultingLink: '',
        domain: {
          'localhost': {
            primaryLanguage: 'eng',
            secondaryLanguage: 'swa',
            primaryLangText: 'English',
            secondaryLangText: 'Swahili'
          },
          'dashboard.mynivi.in': {
            primaryLanguage: 'eng',
            secondaryLanguage: 'hi',
            primaryLangText: 'English',
            secondaryLangText: 'Hindi'
          },
          'india-dashboard-staging.herokuapp.com': {
            primaryLanguage: 'eng',
            secondaryLanguage: 'hi',
            primaryLangText: 'English',
            secondaryLangText: 'Hindi'
          },
          'eu-dashboard-staging.herokuapp.com': {
            primaryLanguage: 'eng',
            secondaryLanguage: 'swa',
            primaryLangText: 'English',
            secondaryLangText: 'Swahili'
          },
          'dashboard.mynivi.ke': {
            primaryLanguage: 'eng',
            secondaryLanguage: 'swa',
            primaryLangText: 'English',
            secondaryLangText: 'Swahili'
          }
        },
        submitted: false,
        actionToBePerformed: 'Add Keyword',
        initialReferralResourceList: [],
        initialReferralResource: null,
        initialQRCodePrinted: false,
        keywordLocation: '',
        keywordLocationDataResp: {
          administrativeLevels: {},
          coordinates: [],
          country: '',
          locality: '',
          mapsLink: '',
          sublocality: ''
        },
        defaultCopykeywordLocationDataResp: {
          administrativeLevels: {},
          coordinates: [],
          country: '',
          locality: '',
          mapsLink: '',
          sublocality: ''
        },
        searchWithoutKeywordLocation: false,
        isLocationRedirectVisible: false,
        env: ''
      }
    },
    methods: {
      checkQRCodePlacement () {
        if (!this.gRowObj.isQRCode) {
          this.gRowObj.qrCodePlacement = ''
        }
      },
      checkKeywordLocation () {
        this.searchWithoutKeywordLocation = false
        this.isLocationRedirectVisible = false
        this.keywordLocationDataResp = this.defaultCopykeywordLocationDataResp
      },
      viewLocationOnMaps () {
        window.open(this.keywordLocationDataResp.mapsLink, '_blank')
      },
      async getKeywordLocationData () {
        try {
          if (!this.keywordLocation) {
            this.searchWithoutKeywordLocation = true
            this.isLocationRedirectVisible = false
            this.keywordLocationDataResp = this.defaultCopykeywordLocationDataResp
            return
          } else if (!this.gRowObj.country) {
            this.isLocationRedirectVisible = false
            this.keywordLocationDataResp = this.defaultCopykeywordLocationDataResp
            return this.$swal({
              type: 'error',
              text: 'Please select country first'
            })
          }
          this.loading = true
          const param = {
            address: this.keywordLocation,
            country: this.gRowObj.country
          }
          const response = await api.buildRequest('getgeolocation', 'GET', param)
          console.log('geolocation: ', response.data.payload)
          if (response.data.payload.type === 'not found') {
            this.loading = false
            this.isLocationRedirectVisible = false
            this.keywordLocationDataResp = this.defaultCopykeywordLocationDataResp
            return this.$swal({
              type: 'error',
              text: response.data.payload.message
            })
          } else if (response.data.payload.data && response.data.payload.data.country && response.data.payload.data.country.toLowerCase() !== this.gRowObj.country.toLowerCase()) {
            this.loading = false
            this.isLocationRedirectVisible = false
            this.keywordLocationDataResp = this.defaultCopykeywordLocationDataResp
            return this.$swal({
              type: 'error',
              text: 'Please enter keyword Location based on selected country'
            })
          }
          this.keywordLocationDataResp = response.data.payload.data
          this.keywordLocationDataResp.keywordLocation = this.keywordLocation
          this.isLocationRedirectVisible = true
          this.loading = false
        } catch (error) {
          this.loading = false
          this.isLocationRedirectVisible = false
          return this.$swal({
            type: 'error',
            text: error.data.payload ? error.data.payload.message : 'An error occurred during fetching keyword location data'
          })
        }
      },
      async getReferralResources (searchQuery) {
        return api.buildRequest('getReferralResources', 'POST', {'query': searchQuery})
        .then(response => {
          let resources = response.data.payload
          let options = []
          resources.forEach(resource => {
            options.push({id: resource.id, label: resource.full_name})
          })
          return options
        })
      },
      async loadOptions ({ action, searchQuery, callback }) {
        if (!searchQuery) {
          this.initialReferralResourceList = await this.getReferralResources()
          if (this.$route.query.keywordId) {
            let response = await api.buildRequest('/getResourceName', 'POST', {id: this.$route.query.keywordId})
            let resources = response.data.payload
            if (resources.length > 0) {
              let isIdExists = false
              this.initialReferralResourceList.forEach((resource) => {
                if (resource.id === resources[0].id) {
                  isIdExists = true
                }
              })
              if (!isIdExists) {
                this.initialReferralResourceList.push({id: resources[0].id, label: resources[0].full_name})
              }
              this.gRowObj.referralResource = resources[0].id
              this.gRowObj.isQRCode = resources[0]['is_QR_code_printed']
            }
            this.initialReferralResource = this.gRowObj.referralResource
            this.initialQRCodePrinted = this.gRowObj.isQRCode
          }
          callback(null, this.initialReferralResourceList)
        }
        if (action === ASYNC_SEARCH && searchQuery.length > 3) {
          let options = await this.getReferralResources(searchQuery)
          callback(null, options)
        }
        if (searchQuery && searchQuery.length < 4) {
          let options = []
          this.initialReferralResourceList.forEach(resource => {
            if (resource.label.toLowerCase().includes(searchQuery.toLowerCase())) {
              options.push(resource)
            }
          })
          callback(null, options)
        }
      },
      openCampaignModel () {
        this.gRowObj.campaignNew = ''
        this.showCampaignModal = true
        this.isSubmittedNewCampaign = false
      },
      closeCampaign () {
        this.gRowObj.campaignNew = ''
        this.showCampaignModal = false
      },
      copyCampaign () {
        let testingCodeToCopy = document.querySelector('#utm_campaign')
        testingCodeToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
        testingCodeToCopy.select()
        document.execCommand('copy')
      },
      copyLink () {
        const storage = document.createElement('textarea')
        storage.value = this.$refs.paramLink.textContent
        this.$refs.paramLink.appendChild(storage)
        storage.select()
        storage.setSelectionRange(0, 99999)
        document.execCommand('copy')
        this.$refs.paramLink.removeChild(storage)
        this.$swal({
          type: 'success',
          text: 'URL parameters copied'
        })
      },
      addCampaign () {
        this.isSubmittedNewCampaign = true
        if (this.gRowObj.campaignNew) {
          this.generateCampaignCode()
          // let campgainCodeNew = this.gRowObj.campaignNew + '(' + this.gRowObj.campaignCode + ')'
          let campgainCodeNew = this.gRowObj.campaignNew
          this.filteredCampaignData.push({name: campgainCodeNew})
          this.gRowObj.campaign = campgainCodeNew
          this.gRowObj.campaignNew = ''
          this.showCampaignModal = false
        }
      },
      loadApps (deployed = false, isFetchNotKeywordDetail) {
        this.loading = true
        let url = 'app'
        url += deployed ? '?deployed=true' : ''
        api.buildRequest(url, 'GET')
          .then(async (response) => {
            if (response.status === 200) {
              if (deployed) {
                this.env = this.env ? this.env : await getEnv()
                this.conversationApps = response.data.payload.apps.map(convo => { return { id: convo.name, type: (convo.config && convo.config.type), label: `${convo.name} - ${this.formatDate(this.env.env === 'production' ? convo.releasedDate : convo.deployedDate, 'd/M/Y hh:ss')}`, stages: convo.config ? convo.config.stages : [] } })
                this.scoutMenus = response.data.payload.apps.map(convo => { return { id: convo.name, label: `${convo.name} - ${this.formatDate(this.env.env === 'production' ? convo.releasedDate : convo.deployedDate, 'd/M/Y hh:ss')}` } })
                this.filteredScoutMenus = this.scoutMenus
              }
              this.conversationAppCopy = this.conversationApps
              this.loading = false
              if (this.checkConvoOrJourney === 'conversation') {
                this.conversationApps = this.conversationAppCopy.filter(item => item.type !== 'journey' && item.type !== 'journeyReminder')
              } else if (this.checkConvoOrJourney === 'journey') {
                this.conversationApps = this.conversationAppCopy.filter(item => item.type === 'journey' || item.type === 'journeyReminder')
              }
            }
            if (this.$route.query.keywordId && !isFetchNotKeywordDetail) {
              this.getKeywordDetails(this.$route.query.keywordId)
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      onChangeClient () {
        if (!this.gRowObj.client) {
          this.gRowObj.campaignCode = ''
          this.gRowObj.utm_campaign = ''
        } else if (this.gRowObj.utm_campaign) {
          this.gRowObj.campaignCode = this.gRowObj.client.substring(0, 3) + '-' + this.gRowObj.utm_campaign
        }
      },
      display () {
        // console.log('source', this.source)
        // console.log('destination', this.destination)
      },
      async onChangeType (event) {
        // Keeping a copy for further use
        this.gRowObj.conversation = null
        this.gRowObj.conversationStage = null
        this.conversationStages = []

        if (this.conversationAppCopy.length === 0) {
          this.conversationAppCopy = this.conversationApps
        }
        this.checkConvoOrJourney = event.target.value
        if (event.target.value === 'conversation') {
          this.conversationApps = this.conversationAppCopy.filter(item => item.type !== 'journey' && item.type !== 'journeyReminder')
        } else if (event.target.value === 'journey') {
          this.conversationApps = this.conversationAppCopy.filter(item => item.type === 'journey' || item.type === 'journeyReminder')
        } else {
          this.conversationApps = []
          this.gRowObj.conversation = null
        }
      },
      onChangeConversation (event) {
        if (event.target.value !== '') {
          console.log(event.target.value)
          this.scoutMenus = []
          this.scoutMenus = this.conversationApps.filter(menu => {
            return menu.id !== event.target.value
          })
          this.filteredScoutMenus = this.scoutMenus
        }
      },
      // NEW METHOD: Handle conversation change and populate stages
      onChangeSelectedConversation (selectedConversationId) {
        // Reset stage selection
        console.log('Selected Conversation ID:', selectedConversationId)
        this.gRowObj.conversationStage = null
        this.conversationStages = []
        if (selectedConversationId) {
          // Find the selected conversation
          const selectedConv = this.conversationApps.find(app => app.id === selectedConversationId)
          console.log('Selected Conversation:', JSON.stringify(selectedConv))
          if (selectedConv && selectedConv.stages) {
            // Transform stages object into dropdown options
            this.conversationStages = Object.keys(selectedConv.stages).map(stageKey => ({
              id: stageKey,
              label: selectedConv.stages[stageKey].stageName || stageKey
            }))
            // console.log('Conversation Stages:', JSON.stringify(this.conversationStages, null, 2))
          }
        }
      },
      onChangeConversationStage (selectedStage) {
        console.log('this.gRowObj.conversationStage', this.gRowObj.conversationStage)
        if (selectedStage) {
          // Add to additionalDetails as jumpState
          this.gRowObj.setAdditionalDetails = {
            ...this.gRowObj.setAdditionalDetails,
            jumpState: selectedStage
          }
        } else {
          // Remove jumpState if no stage selected
          if (this.gRowObj.setAdditionalDetails && this.gRowObj.setAdditionalDetails.jumpState) {
            const updatedDetails = { ...this.gRowObj.setAdditionalDetails }
            delete updatedDetails.jumpState
            this.gRowObj.setAdditionalDetails = updatedDetails
          }
        }
      },
      onChangeList ({source, destination}) {
        console.log('onChangeList fired')
        this.source = source
        this.destination = destination
        console.log(destination)
      },
      getFacilities (facilityName = null) {
        let skip = 0
        let limit = 20
        let selector = {}
        let queryParams = {
          selector: getSelectorValue(selector),
          skip: skip,
          limit: limit,
          fields: ['full_name']
        }
        // console.log(this.destination)
        api.buildRequest('/getFacilities', 'POST', queryParams)
        .then(response => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            this.source = response.data.payload.facilities
            // console.log('this.source')
            // console.log(this.source)
          }
          this.loading = false
        })
      },
      close () {
        // console.log('closing the modal')
        this.submitted = false
        this.$router.replace('keywords_list')
      },
      handleOnboardingChange () {
        if (this.onboardingMode !== 'genai') {
          this.gRowObj.setAdditionalDetails.promptId = null
        }
      },
      async updateCampaignCode () {
        const result = await this.$swal({
          type: 'warning',
          text: 'Do you want to update campaign code',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        })
        return result
      },
      async callWarningToUpdate () {
        let modalResult = await this.updateCampaignCode()
        if (!modalResult.value) {
          return false
        }
        return true
      },
      async addOrUpdate (e) {
        // console.log('inside addOrUpdate function')
        // console.log(this.actionToBePerformed)
        console.log(this.$refs['client'])
        this.submitted = true
        this.keywordExistError = false
        if (!(this.gRowObj.setAdditionalDetails && this.gRowObj.setAdditionalDetails.promptId)) {
          delete this.gRowObj.setAdditionalDetails.promptId
          delete this.gRowObj.setAdditionalDetails.underageLimit
          delete this.gRowObj.setAdditionalDetails.adContext
        }
        if (this.onboardingMode === 'skip') {
          this.gRowObj.setAdditionalDetails = { ...this.gRowObj.setAdditionalDetails, skipOnboarding: true }
        } else {
          delete this.gRowObj.setAdditionalDetails.skipOnboarding
        }
        // var domainname = window.location.hostname
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }
        if (this.keywordLocation && !this.isLocationRedirectVisible) {
          return this.$swal({
            type: 'warning',
            text: 'Please confirm the entered location by clicking on the "Search" button'
          })
        }
        if (this.keywordLocation && this.isLocationRedirectVisible && this.keywordLocationDataResp.country.toLowerCase() !== this.gRowObj.country.toLowerCase()) {
          return this.$swal({
            type: 'error',
            text: 'Please enter keyword Location based on selected country'
          })
        }
        if (!this.gRowObj.campaignCode) {
          let resp = await this.callWarningToUpdate()
          if (resp) {
            return
          }
        }
        let dataCountry = 'data.country'
        let queryParams = {
          selector: {
            keyword: this.gRowObj.keyword,
            [dataCountry]: this.gRowObj.country,
            isdeleted: false
          }
        }
        queryParams.selector = getSelectorValue(queryParams.selector)
        if (this.$route.query.keywordId && !this.$route.query.action) {
          queryParams.selector.id = this.$route.query.keywordId
        }
        this.loading = true
        // if (!this.isEdit) {
        //   this.gRowObj.keyword = this.gRowObj.keyword.toLowerCase()
        // }
        // const isKeywordExist = this.checkKeywordExists(queryParams)
        // NOW CHECK IF THAT KEYWORD ALREADY EXISTS
        api.buildRequest('/checkKeywordExists', 'POST', queryParams)
        .then(async (response) => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            if (response.data.payload === null) {
              let apiToCall = 'addKeyword'
              let trimmedObj = {}
              if (this.destination.length > 0) {
                this.gRowObj.facilities = _.map(this.destination, 'name').join(', ')
              } else {
                this.gRowObj.facilities = ''
              }
              // this.gRowObj.id = this.gRowObj.keyword
              trimmedObj = this.trimJsonObj(this.gRowObj)
              console.log('trimmedObj')
              console.log(trimmedObj)
              if (trimmedObj.conversation) {
                // now find the app id
                const resSmsApp = await this.getSmsAppIdByName(`${trimmedObj.conversation}`)
                console.log('result', resSmsApp)
                if (resSmsApp.status === 200) {
                  if (resSmsApp.data && resSmsApp.data.payload && resSmsApp.data.payload.length) {
                    trimmedObj.conversationId = resSmsApp.data.payload[0].appId
                  }
                }
              }
              if (trimmedObj.scout_menu) {
                // now find the app id
                const resSmsApp = await this.getSmsAppIdByName(`${trimmedObj.scout_menu}`)
                console.log('result', resSmsApp)
                if (resSmsApp.status === 200) {
                  if (resSmsApp.data && resSmsApp.data.payload && resSmsApp.data.payload.length) {
                    trimmedObj.scoutConversationId = resSmsApp.data.payload[0].appId
                  }
                }
              }
              if (this.gRowObj.client === '' || this.gRowObj.client === null) {
                delete trimmedObj.client
              } else {
                const filterClient = this.filteredClientData.filter(obj => obj.name === this.gRowObj.client)
                if (filterClient.length) {
                  trimmedObj.clientId = filterClient[0].id
                }
                // console.log(this.filteredClientData)
              }
              if (this.gRowObj.topic === '' || this.gRowObj.topic === null) {
                delete trimmedObj.topic
              } else {
                const filterTopic = this.topicList.filter(obj => obj.display_name === this.gRowObj.topic)
                if (filterTopic.length) {
                  trimmedObj.topicId = filterTopic[0].id
                }
              }
              if (this.gRowObj.ref_ownership && this.gRowObj.ref_ownership !== 'All') {
                const filterResource = this.referralResourceTypeList.filter(obj => obj.type_name === this.gRowObj.ref_ownership)
                if (filterResource && Object.keys(filterResource).length) {
                  trimmedObj.refOwnershipId = filterResource[0].id
                }
              }
              if (this.gRowObj.ref_service && this.gRowObj.ref_service !== 'All') {
                const filterResource = this.referralResourceTypeList.filter(obj => obj.type_name === this.gRowObj.ref_service)
                if (filterResource && Object.keys(filterResource).length) {
                  trimmedObj.refServiceId = filterResource[0].id
                }
              }
              if (this.gRowObj.ref_access && this.gRowObj.ref_access !== 'All') {
                const filterResource = this.referralResourceTypeList.filter(obj => obj.type_name === this.gRowObj.ref_access)
                if (filterResource && Object.keys(filterResource).length) {
                  trimmedObj.refAccessId = filterResource[0].id
                }
              }
              if (this.gRowObj.ref_ownership) {
                const filterResource = this.referralResourceTypeList.filter(obj => obj.type_name === this.gRowObj.ref_ownership)
                if (filterResource && Object.keys(filterResource).length) {
                  trimmedObj.refOwnershipId = filterResource[0].id
                }
              }
              if (this.gRowObj.campaign === '' || this.gRowObj.campaign === null) {
                delete trimmedObj.campaign
              }
              // console.log('eq', JSON.stringify(this.originalLanguageData.primaryLanguageData) === JSON.stringify(this.primaryLanguageData))
              if (JSON.stringify(this.originalLanguageData.primaryLanguageData) !== JSON.stringify(this.primaryLanguageData)) {
                trimmedObj.editedCustomMsg = 'yes'
              }
              this.simplifyConfigData()
              trimmedObj.customConfig = {}
              if (this.allRows && this.allRows[0] && this.allRows[0].config) {
                trimmedObj.customConfig = this.allRows[0].config
              }
              trimmedObj.conv_type = trimmedObj.appPackage ? trimmedObj.appPackage.toUpperCase() : null
              trimmedObj.appPackage = trimmedObj.appPackage === 'journey' ? 'conversation' : trimmedObj.appPackage
              trimmedObj.keywordLocationData = this.keywordLocation && this.isLocationRedirectVisible ? this.keywordLocationDataResp : null
              if (trimmedObj.keywordLocationData) {
                trimmedObj.insertParamsForLocationToGoogleLocatiotable = trimmedObj.keywordLocationData.insertParamsForLocationToGoogleLocatiotable
                delete trimmedObj.keywordLocationData.insertParamsForLocationToGoogleLocatiotable
              }
              console.log(trimmedObj)
              const newRowObj = {
                id: trimmedObj.keyword,
                keyword: trimmedObj.keyword,
                data: trimmedObj
              }
              let params = {}
              if (this.$route.query.keywordId) {
                apiToCall = 'updateKeyword'
                if (this.$route.query.action === 'copyKeyword') {
                  delete params.updatedRow
                  params.newRow = Object.assign({}, newRowObj)
                  apiToCall = 'addKeyword'
                } else {
                  params.updatedRow = Object.assign({}, newRowObj)
                  params.updatedRow.id = this.$route.query.keywordId
                  params.updatedRow.oldKeywordText = this.keywordOldName
                  params.updatedRow.oldCountryText = this.countryOldName
                  params.updatedRow.campaignOldCode = this.campaignOldCode
                  delete params.newRow
                }
                this.performKeywordOperation(params, apiToCall, 'Keyword added successfully.')
              } else {
                delete params.updatedRow
                params.newRow = Object.assign({}, newRowObj)
                // console.log('addKeyword')
                // console.log(`params.newRow=${JSON.stringify(params.newRow)}`)
                this.performKeywordOperation(params, apiToCall, 'Keyword updated successfully.')
              }
            } else {
              this.loading = false
              this.keywordExistError = true
            }
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      searchFacilities (searchText) {
        console.log('searchFacilities')
        this.loading = true
        let skip = 0
        let limit = 20
        let selector = {}
        if (searchText !== '' && searchText !== undefined) {
          selector.name = searchText
        }
        if (this.destination.length > 0) {
          selector.destination = _.map(this.destination, 'name')
        }
        let queryParams = {
          selector: getSelectorValue(selector),
          skip: skip,
          limit: limit,
          fields: ['full_name']
        }

        // console.log(this.destination)
        api.buildRequest('/searchFacilities', 'POST', queryParams)
        .then(response => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            this.source = response.data.payload.facilities
            // console.log('this.source')
            // console.log(this.source)
          }
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      randomString () {
        let len = 8
        let text = ''
        let chars = '123456789abcdefghijklmnopqrstuvwxyz'
        for (let i = 0; i < len; i++) {
          text += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return text
      },
      generateCampaignCode () {
        this.gRowObj.utm_campaign = this.randomString()
        this.generateLink()
        this.gRowObj.campaignCode = ''
        if (this.gRowObj && this.gRowObj.client) {
          this.gRowObj.campaignCode = this.gRowObj.client.substring(0, 3) + '-' + this.gRowObj.utm_campaign
        } else {
          console.log('Select Company Code first')
        }
      },
      generateLink () {
        let resultingLinkGenerated = ``
        if (this.gRowObj.utm_source) {
          resultingLinkGenerated += `?utm_source=${this.gRowObj.utm_source}`
        }
        if (this.gRowObj.utm_medium && !this.gRowObj.utm_source) {
          resultingLinkGenerated += `?utm_medium=${this.gRowObj.utm_medium}`
        } else if (this.gRowObj.utm_medium) {
          resultingLinkGenerated += `&utm_medium=${this.gRowObj.utm_medium}`
        }
        if (this.gRowObj.utm_campaign && !this.gRowObj.utm_source && !this.gRowObj.utm_medium) {
          resultingLinkGenerated += `?utm_campaign=${this.gRowObj.utm_campaign}`
        } else if (this.gRowObj.utm_campaign) {
          resultingLinkGenerated += `&utm_campaign=${this.gRowObj.utm_campaign}`
        }
        if (resultingLinkGenerated) {
          if (this.gRowObj.keyword) {
            resultingLinkGenerated += `&keyword=${this.gRowObj.keyword}`
            this.resultingLink = resultingLinkGenerated
          } else {
            this.resultingLink = 'please enter keyword first'
          }
        } else {
          this.resultingLink = resultingLinkGenerated
        }
      },
      getFacilitiesExceptSelected (searchText = '') {
        // console.log('getFacilitiesExceptSelected')
        this.loading = true
        let skip = 0
        let limit = 20
        let selector = {}
        if (searchText !== '' && searchText !== undefined) {
          selector.name = searchText
        }
        if (this.destination.length > 0) {
          selector.destination = _.map(this.destination, 'name')
        }
        let queryParams = {
          selector: getSelectorValue(selector),
          skip: skip,
          limit: limit,
          fields: ['full_name']
        }
        // console.log(this.destination)
        api.buildRequest('/getFacilitiesExceptSelected', 'POST', queryParams)
        .then(response => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            this.source = response.data.payload.facilities
            // console.log('this.source')
            // console.log(this.source)
          }
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      getKeywordDetails (keywordId) {
        console.log('getKeywordDetails')
        this.loading = true
        let skip = 0
        let limit = 20
        let selector = {}
        if (keywordId !== '' && keywordId !== undefined) {
          selector = {id: keywordId}
        }
        let queryParams = {
          selector: getSelectorValue(selector),
          skip: skip,
          limit: limit,
          sort: {
            createdAt: -1
          }
        }
        console.log(queryParams)
        api.buildRequest('/getKeywordDetails', 'POST', queryParams)
        .then(response => {
          if (response.status === 200) {
            const keywordDetails = response.data.payload.keywordDetails
            const keywordData = keywordDetails.data
            const selectedFacilities = response.data.payload.selectedFacilities
            // this.gRowObj.id = keywordData.keyword
            this.gRowObj.keyword = keywordData.keyword
            this.keywordOldName = keywordData.keyword
            this.countryOldName = keywordData.country
            this.gRowObj.conversation = keywordData.conversation || null
            let savedStage = null
            if (keywordData.additional_details && keywordData.additional_details.promptId) {
              this.onboardingMode = 'genai'
            } else if (keywordData.additional_details && keywordData.additional_details.skipOnboarding) {
              this.onboardingMode = 'skip'
            } else {
              this.onboardingMode = 'regular'
            }
            if (keywordData.additional_details && keywordData.additional_details.jumpState) {
              savedStage = keywordData.additional_details.jumpState
            }
            this.$nextTick(() => {
              if (this.gRowObj.conversation) {
                // Restore the saved stage
                if (savedStage) {
                  this.gRowObj.conversationStage = savedStage
                }
              }
            })
            this.gRowObj.type = keywordData.type || ''
            this.gRowObj.product = keywordData.product || ''
            this.gRowObj.appPackage = keywordData.appPackage || ''
            this.gRowObj.channel = keywordData.channel || ''
            this.gRowObj.country = keywordData.country || ''
            this.prepareLanguageData()
            this.gRowObj.language = keywordData.language || ''
            this.gRowObj.autoaccepttnc = keywordData.autoaccepttnc
            this.gRowObj.setPreferredUserLanguage = keywordData.set_preferred_user_language || false
            this.gRowObj.setEnableNlpOnboarding = keywordData.enable_nlp_onboarding || false
            this.gRowObj.setAdditionalDetails = keywordData.additional_details || {}
            this.gRowObj.setPreferredUserGender = keywordData.set_preferred_user_gender || 'ASK_THE_USER'
            this.gRowObj.referralcode = keywordData.referralcode
            this.gRowObj.facilities = keywordData.facilities
            this.gRowObj.isExclusive = keywordData.isExclusive || false
            this.gRowObj.weightage = keywordData.weightage || 'primary'
            this.gRowObj.customMessages = keywordData.customMessages || 'no'
            this.gRowObj.campaign = keywordData.campaign || ''
            this.gRowObj.client = keywordData.client || ''
            this.gRowObj.referral_priority = keywordData.referral_priority || 1
            this.gRowObj.mongo_id = keywordData.mongo_id || 1
            this.gRowObj.topic = keywordData.topic || ''
            this.gRowObj.campaignCode = keywordData.campaignCode || ''
            this.gRowObj.ref_ownership = keywordData.ref_ownership || 'All'
            this.gRowObj.ref_service = keywordData.ref_service || 'All'
            this.gRowObj.ref_access = keywordData.ref_access || 'All'
            this.gRowObj.keyword_usage = keywordData.keyword_usage || ''
            this.gRowObj.scout_menu = keywordData.scout_menu || ''
            // this.selectReferral('ownership')
            // this.selectReferral('service')
            // this.selectReferral('access')
            this.gRowObj.tag = keywordData.tag || ''
            this.gRowObj.tag = keywordData.tag || ''
            this.gRowObj.description = keywordData.description || ''
            this.gRowObj.isQRCode = this.initialQRCodePrinted || keywordData.is_QR_code_printed
            this.gRowObj.utm_source = keywordData.utm_source
            this.gRowObj.utm_medium = keywordData.utm_medium
            this.gRowObj.utm_campaign = keywordData.utm_campaign
            this.generateLink()
            this.gRowObj.referralResource = this.initialReferralResource
            this.destination = selectedFacilities || []
            this.gRowObj.customConfig = keywordData.customConfig
            this.gRowObj.createdAt = keywordDetails.createdAt ? keywordDetails.createdAt : new Date()
            this.gRowObj.qrCodePlacement = keywordData.qr_code_placement || ''
            if (keywordData.keywordLocationData) {
              this.keywordLocationDataResp = keywordData.keywordLocationData
              this.keywordLocation = keywordData.keywordLocationData.keywordLocation
              this.isLocationRedirectVisible = true
            }
            if (this.$route.query.action === 'copyKeyword') {
              this.gRowObj.keyword = ''
              // this.gRowObj.campaignCode = ''
            }
            if (this.gRowObj && this.gRowObj.customConfig && Object.keys(this.gRowObj.customConfig).length) {
              this.allRows = [{config: {}}]
              this.allRows[0].config = this.gRowObj.customConfig
            }
            if (keywordData.appPackage === 'conversation') {
              const conv = this.conversationAppCopy.find(item => item.id === keywordData.conversation)
              console.log(this.conversationAppCopy.length)
              console.log(conv)
              if (conv) {
                if (conv.type === 'journey' || conv.type === 'journeyReminder') {
                  this.gRowObj.appPackage = 'journey'
                  this.conversationApps = this.conversationAppCopy.filter(item => item.type === 'journey' || item.type === 'journeyReminder')
                } else {
                  this.gRowObj.appPackage = 'conversation'
                  this.conversationApps = this.conversationAppCopy.filter(item => item.type !== 'journey' && item.type !== 'journeyReminder')
                }
              }
            } else {
              this.conversationApps = []
              this.gRowObj.conversation = null
            }
            this.gRowObj.editedCustomMsg = keywordData.editedCustomMsg
            console.log('this.gRowObj')
            console.log(this.gRowObj)
            console.log('this.destination')
            console.log(JSON.stringify(this.destination))
            this.prepareConfigData()
            if (this.destination.length > 0) {
              this.getFacilitiesExceptSelected()
            } else {
              this.getFacilities()
            }
          }
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      performKeywordOperation (params, apiToCall, message) {
        // console.log(`params=${JSON.stringify(params)}`)
        api.buildRequest(apiToCall, 'POST', params)
          .then(response => {
            if (response.status === 200) {
              if (params.updatedRow && params.updatedRow.keyword) {
                this.keywordOldName = params.updatedRow.keyword
                this.countryOldName = params.updatedRow.data.country
                this.campaignOldCode = params.updatedRow.data.campaignCode
              }
              this.loading = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : message
              })
              if (params.newRow && params.newRow.keyword) {
                this.submitted = false
                this.$router.replace('keywords_list')
              }
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
      },
      /**
       * @author Sarang Sutar <sarang.sutar@mobifillia.com>
       * @description Trim JSON Object
       */
      trimJsonObj (obj) {
        const trimmedObj = {}
        Object.keys(obj).forEach(function (key) {
          // console.log(key, obj[key])
          trimmedObj[key] = obj[key]
          if (obj[key] !== undefined && typeof obj[key] === 'string') {
            trimmedObj[key] = obj[key].trim()
          }
        })
        delete trimmedObj.id
        return trimmedObj
      },
      getCustomMsgData () {
        if (this.languageList.length === 0) {
          this.configNewList = []
          return
        }
        return new Promise(resolve => {
          this.loading = true
          console.log('inside getCustomMsgData')
          api.buildRequest('getAppMessagesFromDB', 'POST', {sheetTitle: 'APP_LAUNCH', sheetReference: 'messagesForApps'})
              .then(response => {
                this.loading = false
                if (response.status === 200) {
                  let filteredClientData = response.data.payload.keywords.filter(applicationMessage => applicationMessage.title === 'APP_LAUNCH')
                  const country = this.gRowObj.country.replace(/_/g, ' ')
                  // -- prepare data countrywise
                  if (filteredClientData[0] && filteredClientData[0].messageType === 'countrywise') {
                    let configNewList = {}
                    for (const msg in filteredClientData[0].config) {
                      if (msg && filteredClientData[0].config[msg].isCustomMessage) {
                        configNewList[msg] = filteredClientData[0].config[msg]
                      }
                    }
                    const applicationMessages = {}
                    for (var messageObj in configNewList) {
                      const countryData = configNewList[messageObj]
                      for (var countryObj in countryData) {
                        if (countryObj === 'displayText') {
                          applicationMessages.displayText = {
                            ...applicationMessages.displayText,
                            [messageObj]: countryData.displayText
                          }
                          applicationMessages.isCustomMessage = {
                            ...applicationMessages.isCustomMessage,
                            [messageObj]: countryData.isCustomMessage
                          }
                        }
                        if (countryObj === country) {
                          const languageData = countryData[countryObj]
                          for (var languageObj in languageData) {
                            if (!applicationMessages[languageObj]) {
                              applicationMessages[languageObj] = {}
                            }
                            if (!languageData[languageObj] && languageObj === 'eng') {
                              if (configNewList && configNewList[messageObj] && configNewList[messageObj].Global && configNewList[messageObj].Global.eng) {
                                applicationMessages[languageObj][messageObj] = configNewList[messageObj].Global.eng
                              } else {
                                applicationMessages[languageObj][messageObj] = ''
                              }
                            } else {
                              applicationMessages[languageObj][messageObj] = languageData[languageObj] || ''
                            }
                          }
                        }
                      }
                    }
                    filteredClientData[0].config = applicationMessages
                  }
                  this.allRows = filteredClientData
                  this.backupKeywordConfig = JSON.parse(JSON.stringify(filteredClientData[0].config))
                  this.prepareConfigData()
                } else {
                  console.log('something went wrong')
                }
                resolve()
              }).catch(({ response }) => {
                this.loading = false
                this.$swal({
                  type: 'error',
                  text: response ? response.data.payload.message : 'An error occurred'
                })
                resolve()
              })
        })
      },
      simplifyConfigData () {
        var finalData = {}
        console.log('simplyfying, ', this.configNewList)
        this.configNewList.forEach(function (item) {
          item.language.forEach(function (lang) {
            if (!finalData[lang.langShortcode]) {
              finalData[lang.langShortcode] = {}
            }
            finalData[lang.langShortcode][item.name] = lang.message
          })
        })
        this.allRows[0].config = finalData
      },
      prepareConfigData () {
        this.configNewList = []
        if (!this.allRows[0]) return

        var configData = this.allRows[0].config

        for (var key in this.backupKeywordConfig.isCustomMessage) {
          this.allRows[0].config[key] = this.backupKeywordConfig[key]
        }

        for (var item in this.gRowObj.customConfig) {
          if (item in this.allRows[0].config) {
            this.allRows[0].config[item] = {...this.allRows[0].config[item], ...this.gRowObj.customConfig[item]}
          }
        }
        console.log('data: ', JSON.parse(JSON.stringify(this.allRows[0].config)))

        if (this.gRowObj.customMessages === 'yes') {
          for (const key in this.allRows[0].config.isCustomMessage) {
            console.log(this.allRows[0].config.isCustomMessage, key)
            if (this.allRows[0].config.isCustomMessage && this.allRows[0].config.isCustomMessage[key]) {
              let data = {
                title: this.allRows[0].config.displayText[key] || key,
                name: key,
                language: []
              }
              this.languageList.forEach(function (item) {
                var message = ''
                for (var config in configData) {
                  if (config === item.langShortcode) {
                    message = configData[config]
                    message = message[data.name]
                  }
                }
                data.language.push({
                  langShortcode: item.langShortcode,
                  langName: item.langName,
                  message: message || ''
                })
              })
              this.configNewList.push(data)
            }
          }
        } else {
          this.configNewList = []
        }
        console.log('NEW CONFIG', this.configNewList)
      },
      closePopup () {
        this.showModal = false
        this.configNewList = JSON.parse(JSON.stringify(this.configNewListCopy))
        this.configNewListCopy = []
      },
      openPopup () {
        if (this.languages.length === 0) {
          this.$swal({
            type: 'error',
            text: 'Please select country first'
          })
          return
        }
        this.showModal = true
        var domainname = window.location.hostname
        console.log('DomainName', domainname)
        console.log('msg', this.gRowObj.editedCustomMsg)
        this.configNewListCopy = []
        this.configNewListCopy = JSON.parse(JSON.stringify(this.configNewList))

        // if (this.gRowObj && this.gRowObj.customConfig && Object.keys(this.gRowObj.customConfig).length) {
        //   this.allRows[0].config = this.gRowObj.customConfig
        // }
        // if (this.allRows.length > 0) {
        //   if (this.allRows[0].config) {
        //     this.primaryLanguageData = this.allRows[0].config[this.domain[domainname].primaryLanguage]
        //     this.secondaryLanguageData = this.allRows[0].config[this.domain[domainname].secondaryLanguage]
        //     this.originalLanguageData = {
        //       primaryLanguageData: _.cloneDeep(this.primaryLanguageData),
        //       secondaryLanguageData: _.cloneDeep(this.secondaryLanguageData)
        //     }
        //     this.primaryLangText = this.domain[domainname].primaryLangText
        //     this.secondaryLangText = this.domain[domainname].secondaryLangText
        //     console.log(this.primaryLangText)
        //     return Object.keys(this.allRows).length
        //   } else {
        //     this.primaryLangText = this.domain[domainname].primaryLangText
        //     this.secondaryLangText = this.domain[domainname].secondaryLangText
        //     return (this.allRows).length + 1
        //   }
        // }
      },
      editPopupMsg (event, key) {
        // var primary = this.$refs['primary_' + key][0]
        // var secondary = this.$refs['secondary_' + key][0]
        // var actionChildren = this.$refs['action_' + key][0].children
        // var height = primary.offsetHeight
        // primary.innerHTML = '<textarea style="width:100%; height:' + height + 'px" >' + primary.innerText + '</textarea>'
        // secondary.innerHTML = '<textarea style="width:100%; height:' + height + 'px">' + secondary.innerText + '</textarea>'
        // primary.children[0].height = height
        // actionChildren[0].style.display = 'none'
        // actionChildren[1].style.display = 'block'
        // actionChildren[2].style.display = 'block'
      },
      savePopupMsg (event, key, index) {
      //   console.log('index', index)
      //   var primary = this.$refs['primary_' + key][0]
      //   var secondary = this.$refs['secondary_' + key][0]
      //   var actionChildren = this.$refs['action_' + key][0].children
      //   console.log('afprimary', this.primaryLanguageData[key])
      //   console.log('afprimarytext', primary)
      //   // const storeData = this.primaryLanguageData
      //   this.primaryLanguageData[key] = primary.children[0].value
      //   this.secondaryLanguageData[key] = secondary.children[0].value
      //   console.log('data', this.allRows[0])
      //   console.log('primary', this.primaryLanguageData[key])
      //   console.log('secondary', this.secondaryLanguageData[key])
      //   primary.innerHTML = this.primaryLanguageData[key]
      //   secondary.innerHTML = this.secondaryLanguageData[key]
      //   this.showAlert('success', 'Message updated successfully!')
      //   // let trimmObj = {}
      //   // let storeObj = {}
      //   // storeObj.campaign = this.allRows[0].campaign.toUpperCase()
      //   // storeObj.config = this.allRows[0].config
      //   // storeObj.campaignType = this.allRows[0].campaignType
      //   // storeObj.id = this.allRows[0]._id
      //  // trimmObj = this.trimJsonObj(storeObj)
      //   // const newRowObj = {
      //   //   id: trimmObj.id,
      //   //   campaign: trimmObj.campaign,
      //   //   config: trimmObj.config,
      //   //   data: trimmObj
      //   // }
      //   // this.performKeywordOperation(newRowObj, 'updateMessages', 'Messages updated successfully.')
      //   actionChildren[0].style.display = 'block'
      //   actionChildren[1].style.display = 'none'
      //   actionChildren[2].style.display = 'none'
      },
      cancelPopupMsg (event, key) {
      //   var primary = this.$refs['primary_' + key][0]
      //   var secondary = this.$refs['secondary_' + key][0]
      //   var actionChildren = this.$refs['action_' + key][0].children
      //   primary.innerHTML = this.primaryLanguageData[key]
      //   secondary.innerHTML = this.secondaryLanguageData[key]
      //  // this.showAlert('warning', 'Are you sure messages will be canceled.')
      //   actionChildren[0].style.display = 'block'
      //   actionChildren[1].style.display = 'none'
      //   actionChildren[2].style.display = 'none'
      },
      getClientData () {
        api.buildRequest('/getClientData', 'POST')
        .then(response => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            this.clientData = response.data.payload
            this.filteredClientData = this.clientData
            // if (query && (!this.gRowObj.client || this.gRowObj.client.text !== query)) {
            //   console.log('query', query)
            // }
            // console.log(this.source)
          }
          // this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      autoCompClientData (test) {
        console.log('Client D', test)
        this.gRowObj.client = test
        if (test) {
          this.filteredClientData = this.clientData.filter(item => item.toLowerCase().includes((test).toLowerCase()))
        } else {
          this.filteredClientData = this.clientData
        }
      },
      autoCompCampgainCodeData (test) {
        console.log('Client Code', test)
        this.gRowObj.campgainCode = test
        if (test) {
          this.filteredCampgainCodeData = this.campgainCodeData.filter(item => item.toLowerCase().includes((test).toLowerCase()))
        } else {
          this.filteredCampgainCodeData = this.campgainCodeData
        }
      },
      prepareLanguageData (type) {
        if (type === 'reset') {
          if (this.gRowObj.customConfig) {
            this.gRowObj.customConfig = {}
          }
        }
        let languageList = []
        let languagesObj = []
        for (var country in this.countryLanguageList) {
          if (this.gRowObj.country === country.replace(/ /g, '_')) {
            this.countryLanguageList[country].forEach(function (item) {
              languageList.push(
                {
                  langShortcode: item.alias,
                  langName: item.name
                }
              )
              languagesObj.push(
                {
                  value: item.alias,
                  name: item.name
                }
              )
            })
          }
        }
        languageList = [...new Map(languageList.map(item => [item['langShortcode'], item])).values()]
        this.languageList = languageList
        languagesObj = [...new Map(languagesObj.map(item => [item['value'], item])).values()]
        this.languages = languagesObj
        // console.log('languageList', this.languageList)
        if (this.languages && Object.keys(this.languages).length) {
          this.gRowObj.language = this.languages[0].value
        } else {
          this.gRowObj.language = ''
        }
        this.getCustomMsgData()
      },
      getLanguageData () {
        return new Promise(resolve => {
          api.buildRequest('languages', 'GET').then(({ data }) => {
            this.countryLanguageList = data.payload
            if (this.countryLanguageList.Global) {
              delete this.countryLanguageList.Global
            }
            if (this.countryLanguageList['United States']) {
              delete this.countryLanguageList['United States']
            }
            this.country = []
            for (var country in this.countryLanguageList) {
              var countryUpdated = country.replace(/ /g, '_')
              this.country.push({name: countryUpdated, value: countryUpdated})
            }
            this.prepareLanguageData()
            resolve()
          })
        })
      },
      getCampaignCodeData () {
        api.buildRequest('/getCampaignCodeData', 'POST')
        .then(response => {
          if (response.status === 200) {
            this.campgainCodeData = response.data.payload
            this.filteredCampgainCodeData = this.campgainCodeData
            console.log('campaign Code', this.campgainCodeData)
          }
          this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      getCampaignData () {
        api.buildRequest('/getCampaignData', 'POST')
        .then(response => {
          // console.log(response)
          // console.log(response.data.payload.facilities)
          if (response.status === 200) {
            this.campaignData = response.data.payload
            this.filteredCampaignData = this.campaignData
            // console.log('campaign', this.campaignData)
            // console.log(this.source)
          }
          // this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      autoCompCampaignData (test) {
        console.log('Campaign D', test)
        this.gRowObj.campaign = test
        if (test) {
          this.filteredCampaignData = this.campaignData.filter(item => item.toLowerCase().includes((test).toLowerCase()))
        } else {
          this.filteredCampaignData = this.campaignData
        }
      },
      getTagData () {
        api.buildRequest('/getTagData', 'POST')
        .then(response => {
          if (response.status === 200) {
            this.tagData = response.data.payload
            this.filteredTagData = this.tagData
            // console.log('Tag', this.tagData)
          }
          // this.loading = false
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      },
      autoCompTagData (test) {
        this.gRowObj.tag = test
        if (test) {
          this.filteredTagData = this.tagData.filter(item => item.toLowerCase().includes((test).toLowerCase()))
        } else {
          this.filteredTagData = this.tagData
        }
      },
      autoCompleteScoutMenus (menu) {
        console.log('inside autoCompleteScoutMenus')
        console.log(menu)
        this.currentScoutMenuIndex = 0
        this.gRowObj.scout_menu = menu
        if (menu) {
          this.filteredScoutMenus = this.scoutMenus.filter(item => item.id.toLowerCase().includes((menu).toLowerCase()))
        } else {
          this.filteredScoutMenus = this.scoutMenus
        }
      },
      // scoutMenuDown () {
      //   console.log('scout menu down')
      //   console.log(this.currentScoutMenuIndex)
      //   if (this.currentScoutMenuIndex < this.scoutMenus.length - 1) {
      //     this.currentScoutMenuIndex++
      //     this.isActive(this.currentScoutMenuIndex)
      //   }
      // },
      // isActive (index) {
      //   console.log(index)
      //   return index === this.currentScoutMenuIndex
      // },
      onclickChangeData (event) {
        console.log('event', event)
        console.log('refs', this.$refs)
        if (this.focusClientAutoComplList) {
          this.focusClientAutoComplList = false
        } else {
          this.showClientAutoComplList = false
        }
        // this.gRowObj.client = data
      },
      showAlert (type, message) {
        this.alert.type = type
        this.alert.message = message
        this.alert.show = true
        setTimeout(() => {
          this.alert.show = false
        }, 3000)
      },
      getSmsAppIdByName (appName) {
        const params = {
          appName: appName
        }
        return new Promise((resolve, reject) => {
          api.buildRequest('/getSmsAppIdByName', 'POST', params)
          .then(response => {
            if (response.status === 200) {
              console.log('inside getSmsAppIdByName')
              console.log(response)
              resolve(response)
            }
            // this.loading = false
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      getReferralResourceType () {
        this.loading = true
        this.refOwnershipData = [{
          id: '',
          type_name: 'All'
        }]
        this.refAccessData = [{
          id: '',
          type_name: 'All'
        }]
        this.refServiceData = [{
          id: '',
          type_name: 'All'
        }]
        return new Promise(resolve => {
          api.buildRequest('/getReferralResourceType', 'POST')
          .then(response => {
            if (response.status === 200) {
              const ownershipTypes = ['Exclude Public', 'Exclude Private']
              const serviceTypes = ['Exclude Medical', 'Exclude Pharmacy']
              const accessTypes = ['Exclude Physical', 'Exclude Virtual']
              this.referralResourceTypeList = response.data.payload
              this.referralResourceTypeList.forEach(function (item) {
                item.type_name = `Exclude ${item.type_name}`
              })

              // -- for ownership
              const ownershipfilteredArray = response.data.payload.filter(i => ownershipTypes.includes(i.type_name))
              this.refOwnershipData = this.refOwnershipData.concat(ownershipfilteredArray)
              // -- for service
              const servicefilteredArray = response.data.payload.filter(i => serviceTypes.includes(i.type_name))
              this.refServiceData = this.refServiceData.concat(servicefilteredArray)
              // -- for access
              const accessfilteredArray = response.data.payload.filter(i => accessTypes.includes(i.type_name))
              this.refAccessData = this.refAccessData.concat(accessfilteredArray)
            }
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      selectAllReferral (event) {
        if (event === 'ownership') {
          if (this.allSelectedRefOwnership) {
            this.gRowObj.ref_ownership = []
            for (const ownership of this.refOwnershipData) {
              this.gRowObj.ref_ownership.push(ownership.id)
            }
          } else {
            this.gRowObj.ref_ownership = []
          }
        } else if (event === 'category') {
          if (this.allSelectedRefCategory) {
            this.gRowObj.refCategory = []
            for (const category of this.refCategoryData) {
              this.gRowObj.refCategory.push(category.id)
            }
          } else {
            this.gRowObj.refCategory = []
          }
        } else if (event === 'service') {
          if (this.allSelectedRefService) {
            this.gRowObj.ref_service = []
            for (const service of this.refServiceData) {
              this.gRowObj.ref_service.push(service.id)
            }
          } else {
            this.gRowObj.ref_service = []
          }
        } else if (event === 'access') {
          if (this.allSelectedRefAccess) {
            this.gRowObj.ref_access = []
            for (const access of this.refAccessData) {
              this.gRowObj.ref_access.push(access.id)
            }
          } else {
            this.gRowObj.ref_access = []
          }
        }
      },
      selectReferral (event) {
        if (event === 'ownership') {
          if (this.gRowObj.ref_ownership.length === this.refOwnershipData.length) {
            this.allSelectedRefOwnership = true
          } else {
            this.allSelectedRefOwnership = false
          }
        } else if (event === 'category') {
          if (this.gRowObj.refCategory.length === this.refCategoryData.length) {
            this.allSelectedRefCategory = true
          } else {
            this.allSelectedRefCategory = false
          }
        } else if (event === 'service') {
          if (this.gRowObj.ref_service.length === this.refServiceData.length) {
            this.allSelectedRefService = true
          } else {
            this.allSelectedRefService = false
          }
        } else if (event === 'access') {
          if (this.gRowObj.ref_access.length === this.refAccessData.length) {
            this.allSelectedRefAccess = true
          } else {
            this.allSelectedRefAccess = false
          }
        }
      },
      async getKeywordUseList () {
        this.loading = true
        return new Promise(resolve => {
          api.buildRequest('/getKeywordUsageTypes', 'POST')
          .then(response => {
            if (response.status === 200) {
              this.keywordUseList = response.data.payload
            }
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getTopics () {
        this.loading = true
        return new Promise(resolve => {
          api.buildRequest('/getTopics', 'POST')
          .then(response => {
            if (response.status === 200) {
              this.topicList = response.data.payload
            }
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      getAllPrompts () {
        return new Promise(resolve => {
          api.buildRequest('/getAllPrompts', 'POST')
          .then(response => {
            if (response.status === 200) {
              if (response.data.payload.prompts && response.data.payload.prompts.length > 0) {
                this.promptList = response.data.payload.prompts.map(prompt => ({
                  id: prompt.id,
                  label: prompt.prompt_name
                }))
              }
            }
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      }
    },
    async mounted () {
      console.log('route query')
      console.log(this.$route.query.keywordId)
      if (this.$route.query.keywordId && this.$route.query.action) {
        this.isEdit = false
      } else if (this.$route.query.keywordId && !this.$route.query.action) {
        this.isEdit = true
      } else {
        this.isEdit = false
      }

      let promiseArray = [
        this.getKeywordUseList(),
        this.getTopics(),
        this.getReferralResourceType(),
        this.getClientData(),
        this.getCampaignData(),
        this.getLanguageData(),
        this.getTagData(),
        this.getCustomMsgData(),
        this.loadApps(true),
        this.getAllPrompts()
      ]
      if (!this.$route.query.keywordId) {
        promiseArray.push(this.getFacilities())
      }
      await Promise.all(promiseArray)
      this.gRowObj = {
        id: null,
        keyword: '',
        conversation: null,
        type: 'chat',
        product: 'asknivi',
        appPackage: '',
        locationid: '',
        channel: '',
        language: '',
        country: '',
        facilities: '',
        campaign: 'GENERAL',
        messages: '',
        client: 'Nivi',
        tag: '',
        description: '',
        overrideuserlocation: '',
        createdAt: new Date(),
        weightage: 'primary',
        autoaccepttnc: false,
        setPreferredUserLanguage: false,
        setEnableNlpOnboarding: false,
        setAdditionalDetails: {},
        setPreferredUserGender: 'ASK_THE_USER',
        referralcode: false,
        customMessages: 'no',
        campaignCode: '',
        campaignNew: '',
        ref_ownership: 'All',
        ref_service: 'All',
        ref_access: 'All',
        keyword_usage: '',
        referral_priority: 1,
        mongo_id: '',
        topicId: '',
        topic: '',
        referralResource: null,
        isQRCode: false,
        qrCodePlacement: ''
      }
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.body.modal-mask {
  position:fixed;
  height: 100vh;
  overflow-y: hidden;
}
.modal-header h3 {
  width: 100%;
  margin-top: 0;
  color: black;
}
.modal-body {
  overflow: auto;
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.disable {
  color: #b3b1b1;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-scout-menus {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 332%;
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.msg-table thead, .msg-table tbody{
  display: inline-block;
}
.msg-table thead{
  width: calc(100% - 17px);
}
.msg-table tbody{
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.msg-table th, .msg-table td {
  display: block;
  float: left;
}
.msg-table th:first-child, .msg-table td:first-child{
  width: calc(20% - 53px);
}
.msg-table th:nth-child(2), .msg-table td:nth-child(2), .msg-table th:nth-child(3), .msg-table td:nth-child(3){
  width: 40%;
}
.msg-table th:nth-child(4), .msg-table td:nth-child(4){
  width: 53px;
}
.alert-success{
   background-color:#d4edda !important; 
   border-color:#d4edda !important
}
.alert-danger{
   background-color:#f7d7da !important; 
   border-color:#f7d7da !important
}
.alert-warning{
   background-color:#fff3cd !important; 
   border-color:#fff3cd !important
}
.alert-info{
   background-color:#cce5ff !important; 
   border-color:#cce5ff !important
}
.facilitytxt:after {
  font-family: "Glyphicons Halflings";
  content: "\e114";
  float: right;
  margin-left: 15px;
}
.facilitytxt.collapsed:after {
  font-family: "Glyphicons Halflings";
  content: "\e080";
  float: right;
  margin-left: 15px;
}
.reload-keyword {
  display: flex;
  align-items: baseline;
}
.swal2-popup .swal2-content {
  font-weight: 600;
}
.style-text-resultingLink {
  display: flex;
  margin-left: 15px;
}
.link {
  flex: 1;
}
.copyToClipborad {
  margin-left: 10px;
}
.keyword-location-search {
  margin-top: 25px;
  display: flex;
  align-items: center;
  padding: 0;
}
.keyword-location-search-btn {
  min-width: 25%;
}
.keyword-location-redirect-btn {
  margin-left: min(10%, 20px);
  margin-top: 2px;
}
.keyword-location-data {
  padding-left: 30px;
}
.custom-margin-top-3 {
  margin-top: 3px;
}
.custom-margin-left-3 {
  margin-left: 3px;
}
</style>


// WEBPACK FOOTER //
// NewKeywordsDetails.vue?5a7bf6b7